module.exports = __webpack_public_path__ + "static/media/guest.7c8b88e8.png";